import React, { useEffect, useMemo } from 'react';
import classes from './SelectedSalesOrder.module.css';
import { fetchServicesTranslations, SalesOrderInfo, selectSalesOrders, selectServicesTranslations, ServiceTranslation ,  } from '../../../store/slices/salesOrders';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { selectUserRole } from '../../../store/slices/auth';
import CustomPagination from '../CustomPagination/CustomPagination';
import { useTranslation } from '../../../hooks/useTranslations';
import { buildTranslatedServicesMap, getTranslatedServicesName } from '../../../utils/miscUtils';

type Props = {
  customer_person_id: number;
  variant?: 'half' | 'full';
  pagination?: boolean;
  isInConsultation?: boolean;
};

export const HistoryTable: React.FC<Props> = ({
  customer_person_id,
  variant,
  pagination,
  isInConsultation,
}) => {
  const salesOrders: SalesOrderInfo[] = useAppSelector<SalesOrderInfo[]>(selectSalesOrders);
  const { translations } = useTranslation();
  const userRole: string = useAppSelector<string>(selectUserRole);
  const lang = localStorage.getItem('lang') || 'en';
     const servicesTranslations= useAppSelector(selectServicesTranslations);
     console.log("servicesTranslations",servicesTranslations)
     const dispatch = useAppDispatch();
  useEffect(() => { dispatch(fetchServicesTranslations()); }, [dispatch]);

  
  const reports = React.useMemo(() => {
    return salesOrders
      .filter(
        (salesOrder) =>
          salesOrder.customer_person.person_id === parseInt(customer_person_id.toString()) &&
          (salesOrder.service_service_group.service_group_id === 3 ||
            salesOrder.service_service_group.service_group_id === 7 ||
            salesOrder.service_service_group.service_group_id === 8 ||
            salesOrder.service_service_group.service_group_id === 11)
      )
      .sort((a, b) => (a.sales_order.datetime_create > b.sales_order.datetime_create ? -1 : 1));
  }, [salesOrders, customer_person_id]);

  const getStatusClass = (status_id: number | undefined) => {
    if (status_id === 2) {
      return classes.statusCompleted;
    } else if (status_id === 1) {
      return classes.statusPending;
    } else if (status_id === 4) {
      return classes.statusParked;
    } else if (status_id === 5) {
      return classes.statusPrepared;
    } else if (status_id === 6) {
      return classes.statusStarted;
    } else if (status_id === 3) {
      return classes.statusVoid;
    }
    return classes.statusOpened;
  };

  const getStatusFromId = (status_id: number | undefined) => {
    if (status_id === 2) {
      return `${translations('closed')}`;
    } else if (status_id === 1) {
      return `${translations('pending')}`;
    } else if (status_id === 4) {
      return `${translations('parked')}`;
    } else if (status_id === 5) {
      return `${translations('prepared')}`;
    } else if (status_id === 6) {
      return `${translations('started')}`;
    }
    return `${translations('open')}`;
  };

  const translatedServicesMap = useMemo(
  () => buildTranslatedServicesMap(servicesTranslations, lang),
  [servicesTranslations, lang]
);

  return (
    <div className={classes.historyTableContainer}>
      <CustomPagination itemsPerPage={10} items={reports}>
        {(paginatedItems: any[]) => (
          <table className={classes.historyTable} border={0} cellSpacing={0}>
            {variant !== 'full' && (
              <thead>
                <tr>
                  <th className={classes.historyTableHead}>ID</th>
                  <th className={classes.historyTableHead}>{translations('name')}</th>
                  <th className={classes.historyTableHead}>{translations('status')}</th>
                  <th className={classes.historyTableHead}>{translations('service')}</th>
                  <th className={classes.historyTableHead}>{translations('booking.date')}</th>
                  <th className={classes.historyTableHead}></th>
                </tr>
              </thead>
            )}
            <tbody>
              {paginatedItems.map((report, index) => (
                <tr
                  key={index}
                  className={
                    index % 2 === 0 ? classes.historyTableRowLight : classes.historyTableRowDark
                  }
                >
                  <td className={`${classes.historyTableColumn} ${classes.historyTableColumnId}`}>
                    {report.sales_order.sales_order_id}
                  </td>
                  <td className={classes.historyTableColumn}>
                    {`${report.customer_person.person_firstname} ${report.customer_person.person_lastname}`}
                  </td>
                  <td className={classes.historyTableColumn}>
                    <div className={getStatusClass(report.work_order?.work_order_status_id)}>
                      {getStatusFromId(report.work_order?.work_order_status_id)}
                    </div>
                  </td>
                  <td className={classes.historyTableColumn}>  {getTranslatedServicesName(report.service.service_id, translatedServicesMap)}</td>
                  <td className={`${classes.historyTableColumn} ${classes.historyTableColumnDate}`}>
                    {moment(report.sales_order.datetime_create)
                      .locale(lang)
                      .format('DD.MM.YYYY | HH:mm')}
                  </td>
                  {userRole !== 'care center agent' && (
                    <td
                      className={
                        report.work_order?.work_order_status_id === 2
                          ? `${classes.historyTableColumn} ${classes.historyTableColumnActions}`
                          : `${classes.historyTableColumn} `
                      }
                    >
                      {report.work_order?.work_order_status_id === 2 && (
                        <Link
                          {...(isInConsultation ? { target: '_blank' } : {})}
                          to={`/web/reports/edit/${report.sales_order.sales_order_id}/${report.sales_order_item.sales_order_item_id}`}
                          className={classes.historyTableActionButton}
                        >
                          {translations('view')}
                        </Link>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </CustomPagination>
    </div>
  );
};


